import { render, staticRenderFns } from "./ViewGatButtonGroup.vue?vue&type=template&id=d7b6af48&scoped=true&"
import script from "./ViewGatButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ViewGatButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b6af48",
  null
  
)

export default component.exports